import { BrowserRouter, Route, Routes } from 'react-router-dom';

// COMPONENTES
import './App.css';
import Navbar from './landing/Navbar'; // <-- Importas tu nuevo Navbar aquí (ajusta la ruta si es necesario)
import YachtBanner from './landing/Yachts';
import Yacht from './landing/yacht/Yacht';

function App() {
  return (
    <BrowserRouter>
      <div className="h-full min-h-screen bg-slate-950 flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<YachtBanner />} />
            <Route path="/:yacht" element={<Yacht />} />
          </Routes>
        </main>

      </div>
    </BrowserRouter>
  );
}

export default App;